<template>
<div class="tw-text-sm font-normal">
    {{ storeAnswer.data.value }}
</div>
</template>
<script>
import mixin from './_mixin_display'
export default { mixins: [mixin] }
</script>